import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandJsaAddPage } from './cabsand-jsa-add';

@NgModule({
  declarations: [
    CabsandJsaAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandJsaAddPage),
  ],
})
export class CabsandJsaAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-jsa-add/cabsand-jsa-add.module.ts